<re-captcha
  #reCaptcha
  (resolved)="setAlternateReCaptcha($event)"
  (error)="setAlternateReCaptchaError($event)"
  errorMode="handled"
></re-captcha>

<div class="form-error" *ngIf="hasAlternateReCaptchaError.invalid || hasAlternateReCaptchaError.expired">
  <div class="form-error__message">
    <ng-container *ngIf="hasAlternateReCaptchaError.invalid && !hasAlternateReCaptchaError.expired">
      {{ "general.message.error.re-captcha.invalid" | translate }}
    </ng-container>
    <ng-container *ngIf="hasAlternateReCaptchaError.expired">
      {{ "general.message.error.re-captcha.expired" | translate }}
    </ng-container>
  </div>
</div>
